import { render } from "./autoprotect-your-account.vue?vue&type=template&id=1e15cf65"
import script from "./autoprotect-your-account.vue?vue&type=script&lang=js"
export * from "./autoprotect-your-account.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__